import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from './config';


@Injectable({
  providedIn: 'root'
})
export class GrupoService {
  user = [];
  constructor(private http: HttpClient) {
  }

  getGrupo() {
    return this.http.get(config.apiUrl+'/Grupo');
  }
}
